import styled from 'styled-components'

export const StyledPageWrapper = styled.div<Partial<{ isLogin: boolean }>>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  z-index: 0;
`
